/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : common.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";
import { BarrierDisplayMode } from "@api-commons/sdk/aaa/AAABarrierWithSource.js";

const domain = "geopop.run";
const host = "api." + domain;
const secure = true;

export const commonConfig: PropertyConfig = {
    version: "8.0.0",
    debug: true,
    host: host,
    domain: domain,
    site: "geopop",
    siteName: "Geopop.it",
    mainUrl: "https://www.geopop.run",
    assetsDistro: "https://api.geopop.run",
    assetsCacheBuster: "1671031069",
    serverSdkEndpoint: "/embed/channel70",
    sdkJsServer: {
        domain: domain,
        host: domain,
        path: "/local/geopop/it/sdk/geopop/it-server-sdk-dev.js",
        secure: true
    },
    secure: secure,
    applicationToken: {

        web: "261792905357|5bEOasDc9UuFVwnA5Byx8fCEgLdMqidtVnkU2p9o7aB83KvfMYuyU8cH2M8xidBk",
        ios: "529171872755|5PdlLRtXni89CcP8E5TexNLcIF7R9fu7T7oyKeMW3OEnj1cVN6wZE6dhlz9JfgNB",
        android: "408557793675|cc7YaNSCEs1NL23Tzt7p0jMxEf7eNHfX8zNY0tf3q4DFHu9HJq58905Jzp8oDFwk"
    },
    cookies: {
        names: {
            session: "gpit_ut",
            logout: "gpit_lo",
            fbToken: "gpit_fbtk",
            aes: "fp_ad",
            loginPreviousState: "gpit_lpsnu",
            lastLoginProvider: "gpit_lprov",
            audienceToken: "apat"
        },
        cookieDomain: ".geopop.run",
        cookieversion: 8,
    },
    loginManager: {
        barrierDisplayMode: BarrierDisplayMode.SHOW_DIALOG,
        actual_providers: {
            facebook: {
                enabled: true,
                applicationIdentifier: "356747945856335",
                scopes: ["public_profile", "email", "user_birthday", "user_gender"]
            },
            google: {
                enabled: true,
                applicationIdentifier: "10786765474-lfkcfvvdn65g6fqss7oah6ujjndjrnis.apps.googleusercontent.com",
                scopes: ["https://www.googleapis.com/auth/user.gender.read", "https://www.googleapis.com/auth/user.birthday.read"]
            },
            apple: {
                enabled: true,
                scopes: ['email', 'name'],
                // @note workaround perchè non utilizzato direttamente
                applicationIdentifier: ""
            },
            email: {
                enabled: true,
                scopes: [],
                applicationIdentifier: ""
            }
        },
        /**
         * firebase app configuration goes here
         */
        firebase: {
            apiKey: "AIzaSyDzRXGnf0WiaTUtjppuUNw8vVCzjXOedaw",
            authDomain: "geopop-users.firebaseapp.com",
            projectId: "geopop-users",
            messagingSenderId: "10786765474",
            appId: "1:10786765474:web:7e289173f085f2e14575fb", 
            measurementId: "G-M97E9G874D"
        },
        autologin: {
            enabled: true,
            retrieveActualDataAlways: false,
        },
        firebaseAccountMergeEnable: true,
        revokeOnClientSideOnDeletion: true
    },
    support: {
        native_apps: true,
        bookmarks: false,
        newsletters: false
    },
    nativeApp: {
        disabled: false,
        product: "geopop",
        schema_intent: "geopopit",
        ios_alternative_url: "https://geopop.it/geopop-ios",
        android_alternative_url: "https://geopop.it/geopop-android",

        dynamicLink: {
            baseUrl: "https://geopopit.page.link/app",
            apn: "com.ciaopeople.geopopit",
            amv: "3",
            ibi: "com.ciaopeople.geopop",
            isi: "1629618093",
            ius: "geopopit"
        }

    },
    webPush: {
        publicKey: "BGYxrnxmISiAx66G_bNbDdZeziZlXvzay5jyg3DHM-duHQtov5Vx83mrr1Mk3d5lTyN5Yh0X7HiGHF52h-a-dZU",
        vapiKey: "BGYxrnxmISiAx66G_bNbDdZeziZlXvzay5jyg3DHM-duHQtov5Vx83mrr1Mk3d5lTyN5Yh0X7HiGHF52h-a-dZU",
        serviceWorkerPath: "/serviceworker/v7/sw.js",
        serviceWorkerHost: "geopop.run"
    },
    snhubConfig: {
        host: host,
        domain: domain,
        secure: secure,
        enabled: false,
        cookies: {
            userdata: "fp_snu_ud",
            token: "fp_snu_tk",
            oldToken: "fp_snu_oldtk",
            next_check: "fp_snu_nc",
            role: "fp_snu_role" 
        }
    },
    ga4: {
        accountId: "G-F8BJ7ERJS6",
        cookieDomain: ".geopop.run"
    },
    contacts: {
        dataDeletionEmail: "richieste-cancellazione@geopop.it" 
    },
    appDownloadLink: {
        "app-store": "https://apps.apple.com/it/app/geopop/id1629618093",
        "google-play": "https://play.google.com/store/apps/details?id=com.ciaopeople.geopopit&hl=it&gl=US"
    },
    links: {
        privacyPolicy: 'https://www.geopop.it/privacy-policy/'
    }
};
